export default "__VITE_ASSET__119c7925__"